<template>
  <router-link :to="href" class="cta-flat u-align--center">
    <span class="u-color--white">{{text}}</span>
  </router-link>
</template>

<script>
  export default {
    name: "v-button-flat",
    props: ['text', 'theme', 'href']
  }
</script>

<style lang="scss">
  .cta-flat {
    width: 100%;
    padding: rem(13px) rem(15px);
    cursor: pointer;
    text-decoration: none;

    span {
      color: white;
      font-weight: 500;
      text-transform: uppercase;
      font-size: rem(14px);
      line-height: rem(24px);

      @include mq($until: MD) {
        line-height: rem(18px);
      }
    }
  }

</style>